import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

const DEFAULT_COLOUR_HEX = '2358a8';

export type ColourAttributeOptions = BaseAttributeOptions;

// Attribute for colour picker fields
export class ColourAttribute extends BaseAttribute {
  constructor(options: ColourAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'colour';
  }

  getInitialValue(): unknown {
    return this.creationValue ? this.creationValue : DEFAULT_COLOUR_HEX;
  }
}
